// extracted by mini-css-extract-plugin
export default {"AsyncSpinLoding":"AsyncSpinLoding_AsyncSpinLoding__Fzfto"};